import { useRouter } from 'next/router';
import React from 'react';
import Cookies from 'react-cookies';
import { useSelector } from 'react-redux';
import { COOKIES } from '../../brands/default/constants';
import { IS_BUY_AGAIN_ENABLED } from '../../brands/default/features';
import { LINK_CHECKOUT } from '../../brands/default/links';
import { redirectToURL } from '../../helpers/url';
import HeaderBuyAgain from './HeaderBuyAgain';
import HeaderIcon from './HeaderIcon';
import HeaderLocation from './HeaderLocation';
import HeaderLogin from './HeaderLogin';
import HeaderSubscribe from './HeaderSubscribe';
import HeaderWishlist from './HeaderWishlist';

const HeaderButtons = () => {
  const router = useRouter();
  const wishlistQuantity = useSelector((state) => state.wishlist.quantity);
  const quantity = useSelector((state) => state.basket.quantity);

  const moveToPage = () => {
    const basketToken = Cookies.load(COOKIES.basketToken);
    if (basketToken && basketToken.length > 10) {
      redirectToURL(`${LINK_CHECKOUT}/${basketToken}`, router);

      return;
    }
    redirectToURL(LINK_CHECKOUT, router);
  };

  return (
    <>
      {IS_BUY_AGAIN_ENABLED && <HeaderBuyAgain />}
      <HeaderLocation />
      <HeaderSubscribe />
      <HeaderLogin />
      <HeaderWishlist quantity={wishlistQuantity} />
      <HeaderIcon
        badgeContent={quantity}
        clickMethod={() => moveToPage()}
        icon="basket"
      />
    </>
  );
};

export default HeaderButtons;
